import React from "react";

import { cn } from "@/src/lib/utils";

import type { JSX, ReactNode } from "react";

interface PageTitleProps {
  children: ReactNode;
  className?: string;
}

function PageTitle({ children, className }: PageTitleProps): JSX.Element {
  return (
    <h1
      className={cn(
        "text-muted-foreground flex items-center gap-2 text-[26px]",
        className,
      )}
    >
      {children}
    </h1>
  );
}

export default PageTitle;
